export const activeUploadControllers: { [jobId: string]: AbortController } = {};

/**
 * Registers an AbortController for a running upload job.
 */
export const registerUploadController = (jobId: string, controller: AbortController) => {
  activeUploadControllers[jobId] = controller;
};

/**
 * Unregisters an upload job's controller.
 */
export const unregisterUploadController = (jobId: string) => {
  delete activeUploadControllers[jobId];
};

/**
 * Aborts and cancels a running upload job.
 */
export const cancelUpload = (jobId: string) => {
  const controller = activeUploadControllers[jobId];
  if (controller) {
    controller.abort();
    delete activeUploadControllers[jobId];
    return true;
  }
  return false;
};
